import hero from "../images/contact_hero.png";
import sc_logo_desk from "../images/logo_home_mobile.png";
import contact_getInTouch from "../images/contact_getInTouch2.png";
import contact_map from "../images/contact_map.png";
import contact_map_mobile from "../images/contact_map_mobile.png";
import donate from "../images/footer_donate.png";
import Footer from "../sections/Footer.js";
import Navbar from "../sections/Navbar.js";
import { useRef, useState, useCallback } from "react";
import useScrollToSection from "../hooks/useScrollToSection";
import SectionReveal from "../components/SectionReveal";

// ── Toggle: set to true for scroll-triggered fade-up on content sections ──
const showSectionReveal = true;

const Contact = () => {
  const contactPageRef = useRef();
  const getInTouchComponent = useRef();
  const addressComponent = useRef();

  // Track navbar overlay state for logo z-index toggle
  const [isNavOverlayActive, setIsNavOverlayActive] = useState(false);
  const handleOverlayActive = useCallback((active) => {
    setIsNavOverlayActive(active);
  }, []);

  // HIDDEN FOR PHASE 1 - DO NOT REMOVE
  // const gettingHereComponent = useRef();

  // Use custom hook to handle URL-based scrolling to sections
  useScrollToSection({
    "Get-in-touch": getInTouchComponent,
    "Our-address": addressComponent
  });

  return (
    <div className="">
      <Navbar whichRef={contactPageRef} currentPage="contact" onOverlayActive={handleOverlayActive} />
      {/* ---------------------------------------------------------------------------------------------------------------
    ---------------------------------------OPENING Contact content--------------------------------------------------------
    ----------------------------------------------------------------------------------------------------------------- */}
      <div className="bg-[#DCB1FA]">
        <div className="mx-auto max-w-[1240px]">
          <a href="/" className="0">
            <img
              src={sc_logo_desk}
              className={`xs:mt-6  md:ml-6 s:ml-12 xs:ml-8   xl:w-[150px] lgx:w-[140px] lg:w-[120px] md800:w-[110px] md:w-[100px] sm:w-[110px] ss:w-[110px] s:w-[100px] xs:w-[90px] absolute top-0 ${isNavOverlayActive ? '' : 'z-[22]'}`}
              alt="secret-circle-logo"
            />
          </a>
          <div className="flex  md:flex-row items-center w-full bg-[#DCB1FA] overflow-hidden">
            <div className="max-w-[1240px]  absolute md:mb-0 md:mt-0 w-[100%] ">
              <h1 className="xs:z-10 xs:relative md:static md:ml-0 xs:text-left md:text-center xs:mb-0  xs:mr-0  xs:ml-[2rem] s:ml-[3rem] sm:ml-[4rem]  md:mt-0  font-sans antialiased mds:text-[4.8rem] mds:leading-[2.2rem] s:text-[3rem] xs:text-[2.8rem] xss:leading-[2.2rem] align-middle text-[#b24029]">
                Contact us
              </h1>
            </div>
            {/* --------------------------------------------------------------------------------------------------------- */}

            <div className=" md:mt-0  md:mb-0 w-[100%]  ">
              <img
                src={hero}
                className=" xs:relative md:static ss:left-[20%] xs:left-[15%] md:left-0  xs:mx-auto md:min-h-[388px] md:max-h-[100vh] ss:h-[100%] xs:h-[188px] ss:mt-0 xs:mt-[18%] hero-img float-right"
                alt="hero"
              />
            </div>
          </div>
        </div>
      </div>
      {/* ---------------------------------------------------------------------------------------------------------------
    ---------------------------------------Get in touch --------------------------------------------------------
    ----------------------------------------------------------------------------------------------------------------- */}
      <div ref={contactPageRef} className="bg-[#F7E1DA]">
        <div
          ref={getInTouchComponent}
          className="mx-auto max-w-[1240px] xs:pt-[0vh] md:pt-[6rem] xs:pb-[50px] md:pb-[110px] "
        >
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col xs:items-center md:items-start md:flex-row w-full bg-[#F7E1DA]  overflow-hidden">
            <div className=" md:ml-16  xs:mb-[7vh] xs:mt-[5vh] md:mt-0  md:mb-0 xs:w-4/5   min-[1050px]:w-[50%] md:w-[50%] ">
              <img
                src={contact_getInTouch}
                className="float-left md:pr-9 md:mt-0 xs:mx-auto max-h-[465px] hidden md:block "
                alt="maternity 1"
              />
            </div>

            {/* --------------------------------------------------------------------------------------------------------- */}
            <div className=" xs:mb-[3vh]  md:mt-0  md:mb-0  xs:w-4/5 md:w-[50%] md:pr-12">
              <p className=" xs:mr-0 xs:ml-0 md:mt-0 md:mr-0 md:ml-0  font-sans antialiased mds:text-[1.3rem] mds:leading-[1.54rem] xss:text-[1.3rem] s:leading-[1.54rem] xss:leading-[1.1rem] tracking- [-0.01em] align-middle text-[#b24029]">
                <h1 className="module-headline">

                  Get in touch
                </h1>
                <p className="module-subhead">
                  <ol className="underline underline-offset-4  decoration-1">
                    <li className="pb-3">
                      <a
                        href="mailto:hello@sistercircle.org.uk"
                        rel="noreferrer"
                        target="_blank"
                      >
                        hello@sistercircle.org.uk
                      </a>
                    </li>
                    <li className="pb-3">
                      <a href="tel:020 7377 8725">020 7377 8725</a>
                    </li>
                  </ol>
                </p>
                
                
                  
                <p className="module-bodycopy">
                  {/* <h2 className="pb-3 pt-10  
                  
                    Email us about:
                  {/* </h2> */}
                  <ol className="list-disc ml-[20px] mt-[10px] mb-[-8px]">
             
                    <li className="pb-3">
                      Volunteering
                      </li>
                    <li className="pb-3">
                      Partnering
                      </li>
                    <li className="pb-3">
                      Funding
                      </li>
                    <li className="pb-3">
                      Getting support
                      </li>
                  </ol>
                </p>
                <div className="responsive-contact-pt responsive-contact-text xs:block md:pl-0 md:block md:w-[450px] mds:w-[380px] xs:w-4/5   
                font-medium text-center  align-bottom">
                  <button className="mt-6 xs:mr-0   md:mr-6   block 
                  px-8 pt-[0.9rem] pb-[0.7rem] 
                  text-white bg-[#ff794e] rounded-full">
                    <a
                      href="https://donorbox.org/sister-circle"
                      rel="noreferrer"
                      target="_blank"
                      className=""
                    >
                      <img
                        src={donate}
                        className="lgx:w-[25px] mdx:w-[22px] md800:w-[18px] md:w-[18px] sm:w-[25px] xs:w-[20px] inline mr-2 mb-1.5"
                        alt="donate"
                      />
                      Donate
                    </a>
                  </button>
                  <button className="mt-5 xs:mr-0 xs:ml-0  md:mr-6  block 
                  px-8 pt-[0.9rem] pb-[1.1rem] 
                  text-[#b24029] bg-[#DCB1FA] rounded-full">
                    <a
                      href="https://sistercirclelondon.typeform.com/SisterCircleRef?"
                      rel="noreferrer"
                      target="_blank"
                    >
                      Get support now
                    </a>
                  </button>
                </div>
              </p>
            </div>
          </div>
          </SectionReveal>
        </div>
      </div>
      {/* ---------------------------------------------------------------------------------------------------------------
    --------------------------------------- Our address --------------------------------------------------------
    ----------------------------------------------------------------------------------------------------------------- */}
      <div className="bg-[#F7E1DA]">
        <div ref={addressComponent} className="bg-[#F7E1DA]">
          <div className="mx-auto max-w-[1240px]">
            <SectionReveal enabled={showSectionReveal}>
            <div className="items-center w-full bg-[#F7E1DA] md:min-h-[652px] overflow-hidden">
              {/* --------------------------------------------------------------------------------------------------------- */}
              <div className="  md:mt-0  md:mb-0   xs:mx-auto xs:w-4/5 md:w-[84%]">
                <h1 className="module-headline module-left ml-0">
            
                  Find us
                {/* </p> */}
                </h1>
                <p className="module-subhead module-left ml-0">
                  Brady Community Centre<br></br>
                  192 Hanbury Street<br></br>
                  London, E1 5HU
                </p>
              </div>

              <div className=" md:mx-auto md:mt-[4rem] xs:mb-[5rem] md:mb-[7rem] xs:mt-[2rem] md:w-[84%] xs:w-[100%] ">
                <a
                  href="https://maps.app.goo.gl/kQFs986zu6fFnXCbA"
                  rel="noreferrer"
                  target="_blank"
                  className="cursor-pointer"
                >
                  <img
                    src={contact_map}
                    // max-w-[820px]
                    className="xs:hidden md:block xs:mx-auto h-[auto] "
                    alt="hero"
                  />
                </a>
                <a
                  href="https://maps.app.goo.gl/kQFs986zu6fFnXCbA"
                  rel="noreferrer"
                  target="_blank"
                  className="cursor-pointer"
                >
                  <img
                    src={contact_map_mobile}
                    className="md:hidden xs:block xs:mx-auto h-[auto]"
                    alt="hero"
                  />
                </a>
              </div>
            </div>
            </SectionReveal>
          </div>
        </div>
      </div>


      <Footer />
    </div>
  );
};

export default Contact;
